import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    derogatoryReport:{},
    drError:'',
    drStatus:'idle'
};

export const fetchDerogatoryReport = createAsyncThunk('credit-audit/fetchDerogatoryReport', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getCreditAuditData',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const CreditAuditSlice = createSlice({
    name:'credit-audit',
    initialState,
    reducers:{
        blankDR:(state)=>{
            state.drStatus = "idle";
            state.derogatoryReport = {};
            state.drError = '';
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchDerogatoryReport.pending, (state)=>{
            state.drStatus = 'loading';
        })
        builder.addCase(fetchDerogatoryReport.fulfilled,(state,action)=>{
            state.drStatus = 'succeeded';
            state.derogatoryReport = action.payload;
            state.drError = '';
        })
        builder.addCase(fetchDerogatoryReport.rejected,(state,action)=>{
            state.drStatus = 'failed';
            state.derogatoryReport = {};
            state.drError = action.error.message;
        })
    }
});

export const {blankCreditBuilder,setIsDataSet} = CreditAuditSlice.actions;

export default CreditAuditSlice.reducer;

